module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reach"
    }
  }, [_c('v-app', {
    attrs: {
      "id": "inspire"
    }
  }, [_c('v-container', {
    staticStyle: {
      "min-height": "0"
    },
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xl12": "",
      "lg12": "",
      "sm12": "",
      "xs12": ""
    }
  }, [_c('v-card-text', [_c('h4', {
    staticStyle: {
      "text-align": "center",
      "margin": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgba(0,0,0,1)",
      "font-weight": "bold"
    }
  }, [_c('span', [_vm._v("Amarthithi-2021")])])]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "text-align": "center",
      "margin": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgba(0,0,0,1)",
      "font-weight": "bold"
    }
  }, [_c('span', [_vm._v("Virtual Program")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_c('strong', [_vm._v("🌹Jai Meher Baba! 🌹")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Beloved Baba's 52nd Amartithi will be conducted online as announced.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left",
      "margin": "0"
    }
  }, [_c('i', [_vm._v("Start Time:")]), _vm._v(" 12:30 hrs IST, 30-Jan-2021.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('i', [_vm._v("End Time:")]), _vm._v(" 04:00 hrs IST, 01-Feb-2021.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left",
      "word-break": "break-word !important"
    }
  }, [_vm._v("Watch the program at: "), _c('a', {
    attrs: {
      "href": "https://avatarmeherbabatrust.org/index.php/avatar-meher-baba-virtual-amartithi-2021/",
      "target": "_blank"
    }
  }, [_vm._v("https://avatarmeherbabatrust.org/index.php/avatar-meher-baba-virtual-amartithi-2021/")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left",
      "margin": "0"
    }
  }, [_vm._v("Alternately, please navigate through these links:")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left",
      "margin": "0",
      "word-break": "break-word !important"
    }
  }, [_vm._v("1) "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/c/AvatarMeherBabaMeherabadStreams/live",
      "target": "_blank"
    }
  }, [_vm._v("https://www.youtube.com/c/AvatarMeherBabaMeherabadStreams/live")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left",
      "word-break": "break-word !important"
    }
  }, [_vm._v("(broadcast may switch to "), _c('a', {
    attrs: {
      "href": "http://www.youtube.com/c/MeherChannel/live",
      "target": "_blank"
    }
  }, [_vm._v("http://www.youtube.com/c/MeherChannel/live")]), _vm._v(" in case of any disruption)")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left",
      "word-break": "break-word !important"
    }
  }, [_vm._v("2) "), _c('a', {
    attrs: {
      "href": "https://www.facebook.com//chirag.gehlot.395/videos/10157831724552196/",
      "target": "_blank"
    }
  }, [_vm._v("https://www.facebook.com//chirag.gehlot.395/videos/10157831724552196/")])]), _vm._v(" "), _c('p', [_vm._v("🌹Avatar Meher Baba Ki Jai!🌹")])])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-240a17d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/amartithi-2021.vue
// module id = 300
// module chunks = 1